"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
function InfoboxMenuItem({ onClick, text, icon, isSelected = false, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const buttonRef = (0, react_1.useRef)(null);
    const handleClick = (0, react_1.useCallback)(() => {
        onClick();
        requestAnimationFrame(() => {
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        });
    }, [onClick]);
    return ((0, jsx_runtime_1.jsxs)(StyledButton, { ref: buttonRef, onClick: handleClick, isSelected: isSelected, "data-e2e": 'InfoboxMenuItem_StyledButton', children: [(0, jsx_runtime_1.jsx)(ui_1.Icon, { name: icon, selected: isSelected, width: 24, height: 24, "data-e2e": 'InfoboxMenuItem_Icon' }), (0, jsx_runtime_1.jsx)(Text, { "data-e2e": 'InfoboxMenuItem_Text', children: t(text) })] }));
}
exports.default = InfoboxMenuItem;
const StyledButton = (0, styled_components_1.default)(ui_1.ToolBarBaseButton) `
  font-weight: 400;
  width: 100%;
  min-width: 168px;
  padding: 4px;
  position: relative;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    padding: 0 8px;
    flex-direction: column;
    gap: 4px;
    min-width: fit-content;
    border-radius: 0;

    &:hover {
      background-color: transparent;
    }
  `)};

  ${({ isSelected, theme }) => isSelected &&
    (0, styled_components_1.css) `
      font-weight: 700;

      ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
        font-weight: 400;
        background-color: transparent;

        &::after {
          content: '';
          position: absolute;
          bottom: -6px;
          left: 0;
          right: 0;
          border-bottom: 4px solid ${theme.grasshopper.menuButtons.active};
        }
      `)};
    `}
`;
const Text = styled_components_1.default.div `
  font-size: 16px;

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    height: 28px;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
  `)};
`;
